import Select from "react-select";
import { Controller } from "react-hook-form";

export function CustomSelect({
	control,
	name,
	options,
	defaultValue,
	styles,
	placeholder,
	getOptionValue,
	getOptionLabel,
	label,
	rules,
	hasHint,
	hint,
	isRequired,
	theme,
	page,
	labelType,
}) {
	return (
		<div>
			<Controller
				control={control}
				name={name}
				defaultValue={defaultValue}
				rules={rules}
				render={({
					field: { onChange, onBlur, value, ref },
					fieldState: { error },
				}) => (
					<div
						className={`relative flex flex-col mb-2 ${
							page === "tier" ? "gap-1" : "gap-0"
						}`}
					>
						{label && (
							<label
								className={`text-[12px] mb-1 
                  ${
										labelType === "overlay"
											? "absolute bg-[white] dark:bg-dark z-[1] top-[-10px] left-2 px-1"
											: ""
									} 
                  ${
										theme === "profile"
											? "!text-[#00000080] dark:!text-softLight"
											: ""
									} 
                  ${error ? "text-[#FF3B30]" : "text-[#1E1E1E]"}`}
							>
								{label}{" "}
								{isRequired && <span className="text-[#FF3B30]">*</span>}
							</label>
						)}

						{hasHint && (
							<p className="absolute top-0 right-0 text-right group">
								<span className="cursor-pointer text-blue-900 text-sm">
									&#9432;
								</span>

								<span className="absolute z-10 p-2 text-white bg-blue-900 rounded-md -top-2 right-0 transform scale-0 group-hover:scale-100 origin-right transition-transform duration-200 text-tiny text-nowrap">
									{hint}
								</span>
							</p>
						)}

						<Select
							options={options}
							placeholder={placeholder}
							isSearchable={true}
							isClearable={true}
							styles={styles}
							getOptionValue={getOptionValue}
							getOptionLabel={getOptionLabel}
							value={options?.find((option) => option?.value === value) ?? ""}
							onChange={(selectedOption) => {
								onChange(selectedOption ? selectedOption.value : null);
							}}
							onBlur={onBlur}
							ref={ref}
							error={!!error}
						/>
						{error && (
							<p className="text-[#FF3B30] text-[10px] mt-1">{error.message}</p>
						)}
					</div>
				)}
			/>
		</div>
	);
}
